import React from 'react';
import { Box, Container, Typography } from '@mui/material';

const MaintenancePage: React.FC = () => {
  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          textAlign: 'center',
          py: 4, // Add some vertical padding
        }}
      >
        <img
          src="/no-app/logo-verify@2x.png" // Path relative to public folder
          alt="GlobalVision Verify Compare Logo"
          style={{ maxWidth: '200px', marginBottom: '32px' }} // Adjust size as needed
        />
        <Typography variant="h4" component="h1" gutterBottom>
          Scheduled Maintenance in Progress
        </Typography>
        <Typography variant="body1">
          We are currently performing essential system maintenance to enhance your experience.
        </Typography>
        <Typography variant="body1">
          Please check back shortly. We appreciate your understanding and patience.
        </Typography>
      </Box>
    </Container>
  );
};

export default MaintenancePage;
